<template lang="pug">
.goals-container(:mq="$mq")
  h2.title(:class="$mq") Quand utiliser Moonly ?
  .goals-content(:class="$mq")
    .goal(:class="$mq")
      h3.subtitle(:class="$mq") Connaître ses cycles
      img.small(src="@/assets/img/suivi-cycle-menstruel-regles-moonly-app.svg" alt="Illustration femme assise avec tablette")
      .description(:class="$mq") Apprends et découvre le fonctionnement de tes cycles naturels en suivant ton ovulation et tes périodes de fécondité
    .goal(:class="$mq")
      h3.subtitle(:class="$mq") Gérer sa contraception
      img(src="@/assets/img/contraception-suivi-ovulation-symptothermie-moonly-app.svg" alt="Illustration femme portant icône Moonly")
      .description(:class="$mq") Protège-toi avec une méthode de contraception naturelle, écologique et efficace
    .goal(:class="$mq")
      h3.subtitle(:class="$mq") Faire un enfant
      img(src="@/assets/img/essai-bebe-tomber-enceinte-moonly-app.svg" alt="Illustration femme enceinte")
      .description(:class="$mq") Le suivi précis de l'ovulation et du cycle menstruel te permet d'augmenter tes chances de faire un bébé
</template>

<script>
export default {
  name: 'Goals'
}
</script>

<style lang="scss" scoped>
@use '@/styles/text';

.goals-container {
  .title {
    @include text.title;
  }

  .goals-content {
    display: grid;
    justify-content: center;
    justify-items: center;

    grid-template-rows: repeat(3, auto);
    grid-template-columns: auto;
    row-gap: 70px;
    &.tablet-landscape,
    &.desktop,
    &.large-desktop {
      margin-top: -30px;
    }

    .goal {
      display: grid;

      &.phone,
      &.tablet-portrait {
        grid-template-areas:
          "title"
          "img"
          "desc";
      }
      &.tablet-landscape,
      &.desktop,
      &.large-desktop {
        grid-template-areas:
          ". img ."
          ". img title"
          ". img desc"
          ". img .";
        &:nth-child(2n) {
          grid-template-columns: 500px 400px 100px;
          grid-template-areas:
            ".     img ."
            "title img ."
            "desc  img ."
            ".     img .";
        }
        row-gap: 30px;
      }

      &.phone {
        grid-template-columns: 260px;
        grid-template-rows: 40px 250px auto;
      }
      &.tablet-portrait {
        grid-template-columns: 400px;
        grid-template-rows: 40px 450px auto;
      }
      &.tablet-landscape {
        grid-template-columns: 0px 400px 490px;
        grid-template-rows: 100px 50px 70px 150px;
        &:nth-child(2n) {
          grid-template-columns: 490px 400px 0;
        }
      }
      &.desktop,
      &.large-desktop {
        grid-template-columns: 100px 400px 500px;
        grid-template-rows: 100px 50px 70px 150px;
      }

      .subtitle {
        grid-area: title;
        @include text.subtitle;
      }

      img {
        grid-area: img;
        max-height: 90%;
        width: auto;
        height: 90%;
        max-width: 100%;
        align-self: center;
        justify-self: center;
        &.small {
          height: 70%;
          padding-bottom: 5%;
        }
      }

      .description {
        grid-area: desc;
        width: 100%;
        @include text.normal;
        font-weight: 300;
      }
    }
  }
}
</style>
